export const person = {
  name: "Nirav Nayak",
  handle: "NN Visuals",
  role: "Product & UI/UX Designer",
  location: "Toronto, Canada",
  yearsExperience: 5,
  clientRetention: 95,
  bio: "Where AI, accessibility, and usability shape thoughtful UI/UX systems. Designing end-to-end experiences enhanced by structure, flow, and subtle micro-animations.",
  email: "niravk.naik@gmail.com",
  phone: "+1 647 514 1712",
  linkedin: "https://www.linkedin.com/in/nirav-nayak/",
  portrait:
    "https://customer-assets-rejwkqb3.emergentagent.net/job_experience-first-8/artifacts/5s1pikz0_Image_20251218_184851_489.webp",
};

export const traits = ["Visual", "Freelancer", "Digital Nomad", "Creative Developer"];

export const projects = [
  {
    slug: "yuja-lumina",
    index: "03",
    title: "Lumina Editor",
    subtitle: "Video Editor Redesign",
    year: "2025",
    role: "Lead UI/UX Designer",
    timeline: "6 weeks",
    tools: ["FigmaMake", "Figma", "Axe DevTools"],
    tags: ["EdTech", "Accessibility", "AI Workflow"],
    summary:
      "From a legacy browser tool to an AI-accelerated, instructor-ready video editing experience — built in FigmaMake.",
    accent: "#ff6b3d",
    nda: true,
    assets: {
      cover: "https://customer-assets-rejwkqb3.emergentagent.net/job_experience-first-8/artifacts/vajxux0e_image.png",
      oldEditor: "https://customer-assets-rejwkqb3.emergentagent.net/job_experience-first-8/artifacts/6p3le5qn_image.png",
      simpleMode: "https://customer-assets-rejwkqb3.emergentagent.net/job_experience-first-8/artifacts/vajxux0e_image.png",
      advancedMode: "https://customer-assets-rejwkqb3.emergentagent.net/job_experience-first-8/artifacts/ixc2ffcm_image.png",
      history: "https://customer-assets-rejwkqb3.emergentagent.net/job_experience-first-8/artifacts/7hnxesok_image.png",
      aiPrompt: "https://customer-assets-rejwkqb3.emergentagent.net/job_experience-first-8/artifacts/arjwfu25_image.png",
    },
    metrics: [
      { value: "1,000+", label: "Institutions supported" },
      { value: "4", label: "Core tasks defined Simple mode" },
      { value: "1", label: "Prototype replaced multiple spec rounds" },
    ],
  },
  {
    slug: "interviewer-experience",
    index: "02",
    title: "The Interviewer Experience",
    subtitle: "Verity by Talview",
    year: "2026",
    role: "Lead Product Designer",
    timeline: "2–3 weeks",
    tools: ["Figma", "FigmaMake", "Miro"],
    tags: ["Enterprise SaaS", "Security", "Live Video"],
    summary:
      "Extending Verity into secure, live interviews — verifiable, monitored, and defensible for hiring teams.",
    accent: "#6366F1",
    nda: true,
    assets: {
      cover: "https://customer-assets-rejwkqb3.emergentagent.net/job_experience-first-8/artifacts/119k6q5r_image.png",
      journey: "https://customer-assets-rejwkqb3.emergentagent.net/job_experience-first-8/artifacts/9klmvdpd_image.webp",
      scheduling: "https://customer-assets-rejwkqb3.emergentagent.net/job_experience-first-8/artifacts/n0lkh7vn_image.webp",
      liveEvents: "https://customer-assets-rejwkqb3.emergentagent.net/job_experience-first-8/artifacts/86ijetp4_image.webp",
      codeEditor: "https://customer-assets-rejwkqb3.emergentagent.net/job_experience-first-8/artifacts/904wpv8c_image.webp",
      rateCandidate: "https://customer-assets-rejwkqb3.emergentagent.net/job_experience-first-8/artifacts/h4tknem7_image.webp",
    },
    metrics: [
      { value: "60%", label: "Faster setup" },
      { value: "3×", label: "Monitoring efficiency" },
      { value: "4.5/5", label: "Target satisfaction" },
    ],
  },
];

export const experience = [
  { company: "YuJa Inc", role: "UX/UI Designer", location: "Toronto", period: "2022 — Present", current: true },
  { company: "Evolveofficial", role: "Product Designer", location: "Toronto", period: "2019 — 2022" },
  { company: "EmerDepot", role: "Graphic Designer", location: "North York", period: "2021" },
  { company: "Elatebrain", role: "Graphic Designer", location: "Ahmedabad", period: "2017 — 2020" },
];

export const testimonials = [
  {
    quote:
      "His ability to merge storytelling with clean interaction design is unmatched. Nirav understands not just how things should look, but why they should look that way — and that insight came through in every part of the work.",
    author: "Shourya Jain",
    title: "Web Designer, BMO",
    avatar: "https://framerusercontent.com/images/qknZSHQ55Ah2LNGZq6bCLgj6Uto.jpeg?width=200&height=200",
  },
  {
    quote:
      "Working with Nirav was more than just hiring a designer — it felt like bringing on a creative partner who truly understood our goals. He took our raw ideas, added clarity, and transformed them into something stunning.",
    author: "Julian Pierce",
    title: "Director",
    avatar: "https://framerusercontent.com/images/9fw1bBJtg86IMXKU6zaCdvYw2Wg.png?width=496&height=496",
  },
  {
    quote:
      "Nirav brings a rare balance of creativity and discipline. He's incredibly fast without ever sacrificing attention to detail. From early ideation to the final product, his process is intentional.",
    author: "Hana Samoto",
    title: "UX Manager",
    avatar: "https://framerusercontent.com/images/vYFurv3Bhpru2Pn28GNGdN5WOk.png?width=896&height=1280",
  },
  {
    quote:
      "Nirav's work was amazing. He captured my vision quickly with minimal back and forth, and was a pleasure to work with.",
    author: "Rebecca Q.",
    title: "Product Manager",
    avatar: "https://framerusercontent.com/images/8M3tPrOo52cFOCgX5hhuze6TXfE.jpg?width=500&height=500",
  },
  {
    quote:
      "I worked with Nirav on a short design project. He brought good ideas to the table and was always enthusiastic and eager to learn.",
    author: "Arupa Tesolin",
    title: "CEO, Speaker, Author",
    avatar: "https://framerusercontent.com/images/hOMMTQB8J0w0vh9hcqDkOYmMdVw.jpeg?width=100&height=100",
  },
];

export const processSteps = [
  { n: "01", title: "Listen & Audit", body: "Interviews, journey maps, competitive analysis. Find the friction that daily users actually feel." },
  { n: "02", title: "Frame the Story", body: "Turn insight into a north star. Every decision must trace back to a specific research quote." },
  { n: "03", title: "Prototype in Motion", body: "Design in FigmaMake, iterate live. Ship a testable artifact instead of a static spec." },
  { n: "04", title: "Refine with Judgment", body: "Rewrite AI outputs. Rebuild for accessibility (WCAG AA). Ship what earns trust." },
];

export const faqs = [
  { q: "What services do you offer?", a: "End-to-end product design: research, IA, wireframes, hi-fi UI, prototypes, design systems, and design-engineering collaboration." },
  { q: "What is your typical turnaround time?", a: "A focused feature ships in 2–3 weeks. Full product redesigns take 6–10 weeks with weekly check-ins." },
  { q: "Do you only work in Figma?", a: "Figma is home base, but I also use FigmaMake, ProtoPie, After Effects, and code (React/Tailwind) when the story needs motion or a live prototype." },
  { q: "Can you handle both design and build?", a: "Yes — I code lightweight React/Tailwind interfaces for prototypes and pair with engineering teams to keep pixels honest in production." },
  { q: "Do you offer brand strategy too?", a: "I lean product-first, but I've shipped identity systems and visual languages when the product needed a consistent voice." },
  { q: "How do you handle revisions and feedback?", a: "Async Loom walkthroughs, tagged Figma comments, and one 30-min sync per week. Two revision rounds are included by default." },
];

export const marqueeTags = [
  "UI/UX Design",
  "Product Thinking",
  "Design Systems",
  "AI-Accelerated",
  "Accessibility",
  "Micro-interactions",
  "FigmaMake",
  "Motion",
  "Prototyping",
  "Research",
];
